import {
  Paper,
  Box,
  Stack,
  Avatar,
  Typography,
  Menu,
  MenuItem,
  IconButton,
  Button,
  Tooltip,
} from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import { Iconify, Label } from "src/components";
import { s3baseUrl } from "src/config";
import { get_zone_date } from "src/utils";
import { wrap_image_with_anchor_and_open_in_new_tab } from "src/utils/regex";
import { useAppContext } from "src/hooks";

// ---------------------------------------------------------
const CommentCard = ({
  item,
  onEdit,
  onDel,
  currentUserRole,
  disabled,
  markCommentAsRead = () => {},
}) => {
  const { dispatch_get_user_profile } = useAppContext();
  const userId = dispatch_get_user_profile().user_id;
  const {
    comment_title,
    comment_type,
    createdAt,
    creator_type,
    comment_creator,
    creator,
    unread_users,
    _id,
  } = item;
  const { first_name, last_name, image } = creator;
  // creator has allow_add_project,allow_drag_drop,role,user for uid,user_status
  const [open, setOpen] = useState(null);
  const parsedContent = (html) => {
    const parser = new DOMParser();
    const parsedContent = parser.parseFromString(html, "text/html");
    const text = parsedContent.body.textContent;
    return text;
  };
  // ---------------------------------------------------------
  const handleClose = () => {
    setOpen(null);
  };
  const handleOpen = (e) => {
    e.stopPropagation();
    if (disabled) {
      return;
    }
    setOpen(e.currentTarget);
  };
  const handleClick = (e, action) => {
    e.stopPropagation();
    setOpen(null);
    if (action === "edit") {
      onEdit(item);
    }
    if (action === "delete") {
      onDel(item);
    }
  };
  const getCommentTime = () => {
    let now = moment(createdAt).fromNow();
    return now;
  };
  const canEditComment = () => {
    if (comment_creator === true) {
      return true;
    }
    // if (String(currentUserRole) === "admin") {
    //   return true;
    // }
    // if (String(currentUserRole) === "manager") {
    //   return true;
    // }

    return false;
  };

  // ---------------------------------------------------------
  return (
    <Paper
      className={`border comment-card-drawer ${
        unread_users?.some((u) => u.user_id === userId) ? "unread-comment" : ""
      }`}
      sx={{ p: 1, position: "relative" }}
      onClick={() => console.log(item)}
      elevation={1}
    >
      {unread_users?.some((u) => u.user_id === userId) && (
        <div
          style={{
            position: "absolute",
            top: "2px",
            left: "3px",
            height: "8px",
            width: "8px",
            backgroundColor: "#FF4842",
            borderRadius: "50%",
            zIndex: 1,
          }}
        />
      )}
      <Stack className="relative" spacing={1} direction="column">
        <Stack direction="row" spacing={1}>
          <Box alignItems="center" justifyContent="center">
            {image ? (
              <Avatar sx={{ height: 34, width: 34 }} src={s3baseUrl + image} />
            ) : (
              // <Avatar src={s3baseUrl + image} />
              <Avatar sx={{ height: 34, width: 34 }}>
                {first_name.substring(0, 2)}
              </Avatar>
            )}
          </Box>
          <Typography
            sx={{
              alignSelf: "center",
              ml: 1,
            }}
            fontWeight="500"
          >
            {first_name + " " + last_name}
          </Typography>
          <Stack
            alignItems="center"
            className="comment-option-bar"
            direction="row"
            spacing={1}
          >
            <Label
              color={String(comment_type) === "0" ? "info" : "error"}
              variant="ghost"
            >
              {String(comment_type) === "0" ? "Public" : "Private"}
            </Label>
            <Typography variant="caption">{getCommentTime()}</Typography>

            {unread_users?.some((u) => u.user_id === userId) && (
              <Tooltip title="Mark as read">
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpen(null);
                    markCommentAsRead("single", _id);
                  }}
                  sx={{ right: "3px", p: 0.5 }}
                >
                  <Iconify icon="bi:check" />
                </IconButton>
              </Tooltip>
            )}

            {canEditComment() && (
              <IconButton
                disabled={disabled}
                onClick={handleOpen}
                sx={{ right: "3px", p: 0.5 }}
              >
                <Iconify icon="mdi:dots-vertical" />
              </IconButton>
            )}
          </Stack>
        </Stack>
        <Stack>
          {/* <Typography
            sx={{ alignSelf: "center", width: 1, whiteSpace: "pre-wrap" }}
          > */}
          {/* {parsedContent(comment_title)} */}
          <div
            className="comment-data"
            dangerouslySetInnerHTML={{
              __html: wrap_image_with_anchor_and_open_in_new_tab(comment_title),
            }}
            style={{
              wordWrap: "break-word",
              wordBreak: "break-word",
            }}
          ></div>
          {/* </Typography> */}
        </Stack>
      </Stack>
      <Menu
        anchorEl={open}
        open={Boolean(open)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{
          p: 0.5,
          mt: 1,
        }}
      >
        <MenuItem
          // selected={isUserSelected(user)}
          onClick={(e) => handleClick(e, "edit")}
          sx={{
            typography: "body2",
            px: 1,
            mx: 0.5,
            borderRadius: 0.5,
            mr: 0,
            marginInline: "3px",
            width: "100%",
            marginTop: "1px",
            marginBottom: "1px",
          }}
        >
          Edit
        </MenuItem>
        <MenuItem
          // selected={isUserSelected(user)}
          onClick={(e) => handleClick(e, "delete")}
          sx={{
            typography: "body2",
            px: 1,
            mx: 0.5,
            borderRadius: 0.5,
            mr: 0,
            marginInline: "3px",
            width: "100%",
            marginTop: "1px",
            marginBottom: "1px",
          }}
        >
          Delete
        </MenuItem>
      </Menu>
    </Paper>
  );
};

export default CommentCard;
